import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHand2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_493_10289",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 56,
			height: 56,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 56,
				height: 56,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_493_10289)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M36.0184 1.379C36.0182 1.37881 36.018 1.37861 36.0179 1.37838C35.3513 0.299303 33.8295 -0.390763 32.5018 0.241356C31.0877 0.915116 30.716 2.23302 30.6991 3.72293C30.6296 10.026 29.7966 16.2385 29.9259 22.5529C29.9383 23.1652 30.0118 24.4392 29.4566 24.9353C28.71 25.6028 28.1576 21.0482 27.9086 19.3134C27.3167 15.1871 26.8858 11.0369 26.4306 6.89126C26.321 5.89343 26.0217 4.98046 25.5953 4.09426C24.9362 2.72567 23.8337 2.15898 22.3919 2.53772C20.9766 2.90906 20.5332 4.08629 20.6174 5.40135C20.9353 10.3825 21.4058 15.3551 21.6498 20.3391C21.8983 25.4165 23.3096 30.5663 20.6038 35.4922C19.0835 38.2601 17.9059 38.64 15.5932 36.4832C14.5252 35.4871 13.6978 34.233 12.6479 33.2146C10.3239 30.9604 7.78748 29.0963 4.29833 29.3788C3.24221 29.4642 2.36908 29.8783 2.06523 30.9581C1.76365 32.0289 2.56562 32.5887 3.2857 33.14C6.88046 35.8932 9.81275 39.2978 12.3192 43.0243C15.6903 47.6928 19.11 52.9735 24.7458 54.9811C29.22 56.6072 34.8185 56.2985 39.0125 53.9719C40.5357 53.125 41.7629 51.9336 42.8202 50.5821C44.506 48.4275 45.6768 45.9101 46.298 43.2385C47.9878 35.9723 49.8674 28.6344 52.8579 21.8251C53.4452 20.4866 54.0377 19.3174 53.9981 17.8218C53.9733 16.8798 53.5627 16.1137 52.5534 15.6929C51.6617 15.321 50.7784 15.6416 50.1046 16.3683C49.4235 17.103 49.1027 18.0285 48.752 18.9495C47.5558 22.091 45.7745 25.113 44.2225 28.1623C43.9802 28.6378 43.7097 29.3469 43.002 29.0752C42.365 28.8303 42.4768 28.1093 42.5096 27.5557C42.7106 24.1875 43.7577 20.9764 44.3677 17.6834C44.9036 14.7896 45.7056 11.9453 46.2365 9.05037C46.5381 7.40441 47.074 5.31877 44.872 4.63931C42.5581 3.92511 41.6421 5.88261 41.1891 7.62937C40.1228 11.7409 38.716 15.7709 38.1128 19.9986C37.953 21.1171 37.6028 22.8462 37.0443 23.1327C36.3598 23.4835 36.3553 22.623 36.3541 22.1582C36.3423 16.9191 36.2389 11.6771 36.4067 6.44303C36.4654 4.60537 36.5693 2.2729 36.0189 1.37962C36.0187 1.37939 36.0186 1.37919 36.0184 1.379Z",
				fill: "url(#paint0_linear_493_10289)"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M33 32V48M33 48L28 43M33 48L38 43",
				stroke: "url(#paint1_linear_493_10289)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_493_10289",
			x1: 28,
			y1: 0,
			x2: 28,
			y2: 56,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#DFCBF5",
				stopOpacity: .4
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#DFCBF5",
				stopOpacity: .1
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_493_10289",
			x1: 33,
			y1: 31,
			x2: 24.0932,
			y2: 38.7079,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF7546" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#EF3863"
			})]
		})] })
	]
});
export default SvgHand2;
